import React from 'react';

export default function MembershipBadge({ user, className = "" }) {
    if (!user) return null;

    if (user.isVendor) {
        return (
            <span className={`inline-flex items-center gap-1 bg-indigo-100 text-indigo-800 text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-wider ${className}`}>
                <span>💼</span> Vendor
            </span>
        );
    }

    if (user.isProPlanner) {
        return (
            <span className={`inline-flex items-center gap-1 bg-yellow-100 text-yellow-800 text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-wider shadow-sm ${className}`}>
                <span>👑</span> Pro Planner
            </span>
        );
    }

    // Default member
    return (
        <span className={`inline-flex items-center gap-1 bg-pink-100 text-pink-800 text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-wider ${className}`}>
            <span>🎉</span> Member
        </span>
    );
}